import { supabase } from './supabase'
import type { AppearanceDescriptions } from './generator/types'

const FUNCTION_URL = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/generate-appearance`

async function callEdgeFunction(body: Record<string, unknown>): Promise<AppearanceDescriptions> {
  // Force a token refresh — getSession() can return a stale cached token
  const { data: { session } } = await supabase.auth.refreshSession()
  const token = session?.access_token
  if (!token) throw new Error('Not authenticated')

  console.log('[Appearance] Calling edge function, token length:', token?.length, 'url:', FUNCTION_URL)

  const res = await fetch(FUNCTION_URL, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'apikey': import.meta.env.VITE_SUPABASE_ANON_KEY,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  })

  const text = await res.text()
  console.log('[Appearance] Response:', res.status, text.slice(0, 300))

  if (!res.ok) {
    let data: any
    try { data = JSON.parse(text) } catch { /* ignore */ }
    throw new Error(data?.error ?? `Appearance generation failed (${res.status})`)
  }

  const data = JSON.parse(text)

  return data.appearances as AppearanceDescriptions
}

/**
 * Generate appearance descriptions for an NPC that hasn't been saved yet.
 * Used during the preview phase after Generate but before Save.
 */
export async function generateAppearancePreview(
  npcData: Record<string, unknown>
): Promise<AppearanceDescriptions> {
  const result = await callEdgeFunction({ mode: 'preview', npc_data: npcData })
  return { ...result, _source: 'claude', _generated_at: new Date().toISOString() }
}

/**
 * Regenerate appearance descriptions for a saved character.
 * Reads current equipment, injuries, and conditions from the database.
 * Updates the character's appearances column.
 */
export async function regenerateAppearance(
  characterId: string
): Promise<AppearanceDescriptions> {
  return callEdgeFunction({ mode: 'regenerate', character_id: characterId })
}
